// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.headerline[data-v-2c1d6bc1] {\n  font-size: 0.75rem;\n  font-weight: bold;\n  color: rgba(0, 0, 0, 0.6);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
